import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { showPreviewPermissionsDrawer } from "components/PreviewPermissions";

import { ANALYTICS } from "../constants";
import { CellComponentProps } from "../types";
import { showUnassignConfirmation } from "../UnassignConfirmation";

type UserRolesListItemActionsDropdownCellProps = CellComponentProps & {
  isLastRole: boolean;
};

const UserRolesListItemActionsDropdownCell = ({
  roleBinding,
  isLastRole,
}: UserRolesListItemActionsDropdownCellProps) => {
  return (
    <DropdownMenuEllipsis tooltip="Role actions">
      <DropdownMenuItem
        {...ANALYTICS}
        analyticsTitle="Preview permissions clicked"
        onAction={() => showPreviewPermissionsDrawer({ roleId: roleBinding.role.id })}
      >
        Preview permissions
      </DropdownMenuItem>
      <DropdownMenuItem
        {...ANALYTICS}
        danger
        analyticsTitle="Unassign clicked"
        onAction={() =>
          showUnassignConfirmation({ id: roleBinding.id, name: roleBinding.role.name, isLastRole })
        }
      >
        Unassign
      </DropdownMenuItem>
    </DropdownMenuEllipsis>
  );
};

export default UserRolesListItemActionsDropdownCell;
